import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@/environments/environment";
import {BehaviorSubject, map, Observable} from "rxjs";
import {User, UserWallet, WalletTransaction, WalletTransactionItem, WalletType} from "../interface/user.interface";
import {PagingResponseModel} from "@/app/shared/interface/pagination.interface";

@Injectable({
    providedIn: "root",
})
export class WalletService {

    private userWalletSubject = new BehaviorSubject<UserWallet | null>(null);
    userWallet$ = this.userWalletSubject.asObservable();
    setUserWallet(wallet: UserWallet) {
        this.userWalletSubject.next(wallet);
    }

    private userPointWalletSubject = new BehaviorSubject<UserWallet | null>(null);
    userPointWallet$ = this.userPointWalletSubject.asObservable();

    setUserPointWallet(wallet: UserWallet) {
        this.userPointWalletSubject.next(wallet);
    }

    refreshWallet(userName: string, type: WalletType) {
        return this.getUserWallet({ userName, walletType: type }).subscribe(res => {
            if (res) {
                if (type === WalletType.Coin) {
                    this.setUserWallet(res);
                } else if (type === WalletType.Point) {
                    this.setUserPointWallet(res);
                }
            }
        });
    }

    constructor(private http: HttpClient) { }

    claimVoucher(body: any) {
        return this.http.post<UserWallet>(`${environment.baseURL}user/wallet/claim-coin-voucher`, body);
    }
    clearWallets() {
      this.userWalletSubject.next(null);
      this.userPointWalletSubject.next(null);
    }

    getUserWallet(body: any) {
        return this.http.post<UserWallet>(`${environment.baseURL}user/wallet/retrieve-wallet`, body);
    }

    getUserWalletTransaction(body: any) {
        return this.http.post<WalletTransaction>(`${environment.baseURL}user/wallet/retrieve-transactions`, body);
    }
}
